import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './store/index';
import { jwtInterceptor } from './helpers/jwtInterceptor';
import 'antd/dist/antd.variable.min.css';
import { ConfigProvider } from 'antd';
import { useTranslation } from 'react-i18next';
import { errorAxiosInterceptor } from './helpers/errorInterceptor';
import './i18n';

import enUS from 'antd/lib/locale/en_US';
import deDE from 'antd/lib/locale/de_DE';
import srRS from 'antd/lib/locale/sr_RS';

ConfigProvider.config({
  theme: {
    primaryColor: '#3d996f',
  },
});

jwtInterceptor();
// errorAxiosInterceptor();

const AppWrapper = () => {
  const { i18n } = useTranslation();

  const getAntdLocale = (lang) => {
    switch (lang) {
      case 'de':
        return deDE;
      case 'sr':
        return srRS;
      default:
        return enUS;
    }
  };

  const [antdLocale, setAntdLocale] = React.useState(null);

  useEffect(() => {
    const locale = getAntdLocale(i18n.language);
    setAntdLocale(locale);
  }, [i18n.language]);

  if (!antdLocale) return null;

  return (
    <ConfigProvider locale={antdLocale}>
      <App />
    </ConfigProvider>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <AppWrapper />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);

reportWebVitals();
